// extracted by mini-css-extract-plugin
module.exports = {"subscribePrivacyTermsandConditions":"styles-module__subscribePrivacyTermsandConditions___Wi-z5"};